import _ from "lodash";
import axios from "axios";

import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import generateQuery from "helpers/query";
import { ROLE_IDS, CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_DELIVERIES_REQUEST: "GET_DELIVERIES_REQUEST",
  GET_DELIVERIES_SUCCESS: "GET_DELIVERIES_SUCCESS",
  GET_DELIVERIES_FAILURE: "GET_DELIVERIES_FAILURE",
  GET_DELIVERY_REQUEST: "GET_DELIVERY_REQUEST",
  GET_DELIVERY_SUCCESS: "GET_DELIVERY_SUCCESS",
  GET_DELIVERY_FAILURE: "GET_DELIVERY_FAILURE",
  GET_DELIVERY_LINES_REQUEST: "GET_DELIVERY_LINES_REQUEST",
  GET_DELIVERY_LINES_SUCCESS: "GET_DELIVERY_LINES_SUCCESS",
  GET_DELIVERY_LINES_FAILURE: "GET_DELIVERY_LINES_FAILURE",
  GET_FUST_LINES_REQUEST: "GET_FUST_LINES_REQUEST",
  GET_FUST_LINES_SUCCESS: "GET_FUST_LINES_SUCCESS",
  GET_FUST_LINES_FAILURE: "GET_FUST_LINES_FAILURE",
  GET_COST_LINES_REQUEST: "GET_COST_LINES_REQUEST",
  GET_COST_LINES_SUCCESS: "GET_COST_LINES_SUCCESS",
  GET_COST_LINES_FAILURE: "GET_COST_LINES_FAILURE"
};

export default class Actions {
  public static getDeliveries(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "deliveries.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(savedSettings, `${CUSTOM_SETTINGS.deliveries}.pageSize`, 10)
        );
      }

      const url = `ShipmentsExtended?$expand=OtherRelation,Lines/OrderLine/Order,
        Lines/Item,Supplier,Seller
        &$select=Id,DocumentId,DeliveryId,RoleId,Date,DeliveryDate,
        OtherRelation/Name,OtherRelation/Number,Seller/Name,Seller/Number,Seller/FytosanitairNumber,
        Supplier/Name,Supplier/Number,Bio,Read
        ${generateQuery(meta, "RelationId")} and IsFinal`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0)
        };
        dispatch(success(payload, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_DELIVERIES_REQUEST };
    }
    function success(payload, meta) {
      return { type: actionTypes.GET_DELIVERIES_SUCCESS, payload, meta };
    }
    function failure(error) {
      return { type: actionTypes.GET_DELIVERIES_FAILURE, error };
    }
  }

  public static getDelivery(id, roleId = "") {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));
      const roleLabel = roleId.split("=")[1];

      const roleIdFilter =
        roleId.length > 0 ? ` and RoleId eq '${ROLE_IDS[roleLabel]}'` : "";

      const url = `ShipmentsExtended?$filter=Id eq ${id}${roleIdFilter}
        &$expand=OtherRelation,OtherRelation/PrimaryAddress/Country,Supplier,
        Supplier/PrimaryAddress/Country,Seller,Seller/PrimaryAddress/Country
        &$select=Id,DeliveryId,RoleId,Date,DeliveryDate,DocumentId,
        OtherRelation/Name,OtherRelation/OfficeNumber,OtherRelation/FaxNumber,OtherRelation/MailAddress,
        OtherRelation/PrimaryAddress/Address1,OtherRelation/PrimaryAddress/ZipCode,
        OtherRelation/PrimaryAddress/City,OtherRelation/PrimaryAddress/Country/ISOCode,OtherRelation/Number,
        Seller/Name,Seller/Number,Seller/FytosanitairNumber,Supplier/Name,Supplier/OfficeNumber,
        Supplier/FaxNumber,Supplier/MailAddress,Supplier/PrimaryAddress/Address1,
        Supplier/PrimaryAddress/ZipCode,Supplier/PrimaryAddress/City,
        Supplier/PrimaryAddress/Country/ISOCode,Supplier/Number,
        Transporter,Bio,SkalNumber`;

      try {
        const {
          data: {
            value: [delivery]
          }
        } = await axios.get(url);
        dispatch(success(delivery));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_DELIVERY_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_DELIVERY_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_DELIVERY_FAILURE, error };
    }
  }

  public static getDeliveryLines(id, roleId) {
    return async dispatch => {
      dispatch(request());

      const url = `ShipmentLines?$filter=ShipmentId eq ${id}
        &$expand=Shipment,ShippedQuantityUnit,Item,Class,OrderLine/Order,Size,Invoices/Invoice
        &$select=Shipment/DeliveryId,Number,ShippedQuantity,ShippedQuantityUnit/Description,
        TypeId,Item/Description,GrowerClaims,Bio,CertificateNumber,Size/Description,
        CertificateType,Class/Code,AMStatus,OrderLine/Order/Id,OrderLine/Order/Number,
        Invoices/Invoice/Id,Invoices/Invoice/Number
        &$orderby=Number asc`;

      try {
        const {
          data: { value }
        } = await axios.get(url);
        const payload = _.map(value, item => ({ ...item, RoleId: roleId }));
        dispatch(success(payload));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_DELIVERY_LINES_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_DELIVERY_LINES_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_DELIVERY_LINES_FAILURE, error };
    }
  }

  public static getFustLines(id, roleId) {
    return async dispatch => {
      dispatch(request());

      const url = `ShipmentFustLines?$filter=ShipmentLine/ShipmentId eq ${id}
        &$expand=ShipmentLine,Order,Item,Invoices/Invoice        
        &$select= Number,Quantity,OwnerTypeId,Transfer,Item/Description,Price,
        Order/Id,Order/Number,Invoices/Invoice/Id,Invoices/Invoice/Number,Invoices/RelationId
        &$orderby= Number asc`;

      try {
        const {
          data: { value }
        } = await axios.get(url);
        const payload = _.map(value, item => ({ ...item, RoleId: roleId }));
        dispatch(success(payload));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_FUST_LINES_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_FUST_LINES_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_FUST_LINES_FAILURE, error };
    }
  }

  public static getCostLines(id, roleId) {
    return async dispatch => {
      dispatch(request());

      const url = `ShipmentCostLines?$filter= ShipmentLine/ShipmentId eq ${id}        
        &$expand=ShipmentLine,Order,Item,Invoices/Invoice
        &$select=Number,Item/Description,Amount,Specification,
        Order/Id,Order/Number,Invoices/Invoice/Id,Invoices/Invoice/Number,Invoices/RelationId
        &$orderby=Number asc`;

      try {
        const {
          data: { value }
        } = await axios.get(url);
        const payload = _.map(value, item => ({ ...item, RoleId: roleId }));
        dispatch(success(payload));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_COST_LINES_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_COST_LINES_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_COST_LINES_FAILURE, error };
    }
  }
}
